import React, { useState } from "react";
import "./Loader.css";
import Spinner from "./spinner.gif";

const FullPageLoader = () => {
  return (
    <div className="fp-container">
      <img src={Spinner} className="fp-loader" alt="loading" />
    </div>
  );
};

const useFullPageLoader = () => {
  const [loading, setLoading] = useState(false);

  return [
    loading ? <FullPageLoader /> : null,
    () => setLoading(true), //Show loader
    () => setLoading(false), //Hide Loader
  ];
};

const SkeletonLoad = ({ num = 4 }) => {
  return (
    <div className="card">
      <div className="card-body p-5">
        {Array.from({ length: num }).map((_, index) => (
          <span key={index} className="skeleton-box w-100"></span>
        ))}
      </div>
    </div>
  );
};

const Error404 = () => {
  return (
    <div className="text-center card bg-light">
      <div className="card-body">
        <span className="svg-icon svg-icon-primary svg-icon-3x d-block mb-5">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <rect x="0" y="0" width="24" height="24" />
              <path
                d="M20.4061385,6.73606154 C20.7672665,6.89656288 21,7.25468437 21,7.64987309 L21,16.4115967 C21,16.7747638 20.8031081,17.1093844 20.4856429,17.2857539 L12.4856429,21.7301984 C12.1836204,21.8979887 11.8163796,21.8979887 11.5143571,21.7301984 L3.51435707,17.2857539 C3.19689188,17.1093844 3,16.7747638 3,16.4115967 L3,7.64987309 C3,7.25468437 3.23273352,6.89656288 3.59386153,6.73606154 L11.5938615,3.18050598 C11.8524269,3.06558805 12.1475731,3.06558805 12.4061385,3.18050598 L20.4061385,6.73606154 Z"
                fill="#000000"
                opacity="0.3"
              />
              <polygon
                fill="#000000"
                points="14.9671522 4.22441676 7.5999999 8.31727912 7.5999999 12.9056825 9.5999999 13.9056825 9.5999999 9.49408582 17.25507 5.24126912"
              />
            </g>
          </svg>
        </span>
        The item you're looking for doesn't exist.
      </div>
    </div>
  );
};

export default FullPageLoader;
export { useFullPageLoader, SkeletonLoad, Error404 };
